export function safelyParseJSON(json: string) {
  let parsed;

  try {
    parsed = JSON.parse(json);
  } catch (_e) {
    parsed = {};
  } finally {
    return parsed;
  }
}
